import React from 'react';
import { Form } from 'react-bootstrap';
import _ from 'lodash';
import { isImage } from 'utils/validate';
import { t } from 'i18next';

const ReactstrapFile = ({
    field: { ...fields },
    form: { touched, errors, setFieldValue, setFieldTouched },
    isVideoFile,
    ...props
}) => {
    // const fileInputRef = useRef(null);
    const { id, dimensionProps, fileName, ...rest } = props;
    const uniqueId = Math.random().toString();
    const fileStyle = { opacity: '0' };
    const displayFile = () => {
        if (!_.isEmpty(fields.value) && _.isString(fields.value) && isVideoFile) {
            return (
                <div style={{ width: '50%' }}>
                    <span className="d-block text-truncate" title={fields.value}>
                        {fields.value}
                    </span>
                </div>
            );
        }
        if (!_.isEmpty(fields.value) && _.isString(fields.value) && isImage(fields.value)) {
            return (
                <img
                    style={{ maxWidth: '25%', maxHeight: '38px', height: 'auto', width: 'auto' }}
                    src={`${process.env.REACT_APP_DRIVER_PORTAL_URL}/${fields.value}`}
                    alt=""
                />
            );
        }
        if (!_.isEmpty(fields.value) && _.isString(fields.value)) {
            return (
                <a
                    style={{ textDecoration: 'underline', color: '#007bff' }}
                    href={`${process.env.REACT_APP_DRIVER_PORTAL_URL}/${fields.value}`}
                    target="__black"
                >
                    {fileName}
                </a>
            );
        }
        return '';
    };

    // const errors = {
    //     images: [null, "error message", null],
    // }

    const fieldName = fields.name.split('.');
    return (
        <Form.Group controlId={id} className="form-group">
            <div className="form-file">
                <label className="form-file-label">{rest.label}</label>
                <Form.Control
                    {...rest}
                    type="file"
                    className="form-control-file custom-file-class"
                    style={fileStyle}
                    isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                    onChange={(e) => {
                        setFieldTouched(fields.name, true);
                        if ((e.currentTarget as any).files[0]) {
                            setFieldValue(fields.name, (e.currentTarget as any).files[0]);
                        } else {
                            setFieldValue(fields.name, '');
                        }
                    }}
                    onBlur={() => {
                        setFieldTouched(fields.name, true);
                    }}
                    id={`files-${uniqueId}`}
                />
            </div>
            <div
                className="file-row"
                style={
                    props.disabled
                        ? { background: '#f2f2f2', padding: '10px', alignItems: 'center' }
                        : { alignItems: 'center' }
                }
            >
                <label title={t('ChooseFile')} htmlFor={`files-${uniqueId}`} className="file-input">
                    {t('ChooseFile')}
                </label>
                <span className="text-truncate">{fields.value.name ? fields.value.name : t('noFileChosen')}</span>
                {displayFile()}
            </div>
            {touched[fields.name] && errors[fields.name] && errors[fields.name] !== 'required' && (
                <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                    {errors[fields.name]}
                </Form.Control.Feedback>
            )}

            {Object.keys(errors).length &&
            fieldName.length > 1 &&
            errors[fieldName[0]] &&
            errors[fieldName[0]][fieldName[1]] ? (
                <Form.Control.Feedback
                    className="pb-0 error invalid-feedback d-block custom-error-message"
                    type="invalid"
                >
                    {errors[fieldName[0]][fieldName[1]]}
                </Form.Control.Feedback>
            ) : (
                ''
            )}
        </Form.Group>
    );
};
export default ReactstrapFile;
